<template>

	<div class="image-row">
		<ul>
			<slot name="items" />
		</ul>
	</div>

</template>

<script>

	export default {
		name: "ImageRow"
	}

</script>

<style lang="scss" scoped>

	@import "media.scss";
	@import "list-style-reset.scss";
	@import "responsive-font.scss";

	ul {
		@include list-style-reset;
		color:#6D6E71; overflow:hidden; padding:0 5vw; margin-bottom:10vw;
		@include media(large) {
			display:flex; justify-content:space-between; padding:0 9.1rem;
		}
		@include media(xxlarge) {
			margin-bottom:14rem;
		}
		li {
			@include media(large) {
				width:25%; max-width:33.5rem;
			}
			& + li {
				@include media(small, large) {
					margin-top:4rem;
				}
				@include media(large) {
					margin-left:3vw;
				}
			}
		}
		strong {
			font-weight:600; color:#3D3D3D;
		}
		p {
			margin:4rem 0 0;
			@include media(small, large) {
				margin-top:2rem;
			}
		}
		img {
			display:block; width:100%;
			@include media(small, large) {
				margin-left:10vw; padding-top:2rem;
			}
		}
	}

</style>



// WEBPACK FOOTER //
// src/components/Products/ImageRow.vue